import { render, staticRenderFns } from "./UnitsAdmin.vue?vue&type=template&id=feb32aee"
import script from "./UnitsAdmin.vue?vue&type=script&lang=js"
export * from "./UnitsAdmin.vue?vue&type=script&lang=js"
import style0 from "./UnitsAdmin.vue?vue&type=style&index=0&id=feb32aee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports